import { GradingScheme } from '../models/grading-scheme.model';

export class SetGradingSchemeToModuleSuccess {
    static readonly type = '[GradingScheme] SetGradingSchemeToModuleSuccess';

    constructor(
        public payload: {
            gradingScheme: GradingScheme;
        }
    ) {}
}
